namespace GeniuzPOS.QRreport {
    export interface QRywcSpec_icrp05Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DocMonth: Serenity.LookupEditor;
        DocYear: Serenity.DateYearEditor;
        Qty_AmtFg: Serenity.RadioButtonEditor;
        ShopTypeId: Serenity.LookupEditor;
        ShopGroupId: Serenity.LookupEditor;
        ShopId: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        SkuCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        SupplId: Serenity.LookupEditor;
        ConsignFg: Serenity.EnumEditor;
    }

    export class QRywcSpec_icrp05Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec_icrp05';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec_icrp05Form.init)  {
                QRywcSpec_icrp05Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateYearEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.EnumEditor;

                Q.initFormType(QRywcSpec_icrp05Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DocMonth', w0,
                    'DocYear', w3,
                    'Qty_AmtFg', w4,
                    'ShopTypeId', w0,
                    'ShopGroupId', w0,
                    'ShopId', w0,
                    'WhsId', w0,
                    'SkuCode', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'StyleId', w0,
                    'ColorId', w0,
                    'SizeId', w0,
                    'TasteId', w0,
                    'MatTypeId', w0,
                    'SupplId', w0,
                    'ConsignFg', w5
                ]);
            }
        }
    }
}
